
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getWindowWidth } from '../../../base/environment/utils';
import { InlineDialogWithoutAnalytics } from '../../../base/react/components/web/InlineDialog';
import { toggleReactionsMenuVisibility } from '../../actions.web';
import { getReactionsMenuVisibility } from '../../functions.web';

import ReactionsMenu from './ReactionsMenu';


type Props = {

    /**
    * Component's children (the reactions menu button).
    */
    children: React$Node
}

/**
 * Popup with reactions menu.
 *
 * @returns {ReactElement}
 */
function ReactionsMenuPopup({
    children
}: Props) {
    /**
    * Flag controlling the visibility of the popup.
    */
    const isOpen = useSelector(state => getReactionsMenuVisibility(state));
    const _conferenceView = useSelector(state => state['features/base/conference'].conferenceView);

    const dispatch = useDispatch();
    const onClose = useCallback(args => {
        const event = args?.event;

        if (event && event.target) {
            const target = event.target;

            if (!target.ownerDocument?.documentElement?.contains(target)) {
                return;
            }

            if (target.closest('.reactions-menu') || target.closest('.reactions-menu-popup-container')) {
                return;
            }
        }
        dispatch(toggleReactionsMenuVisibility());
    }, [ dispatch ]);


    return (
        <div>
            <InlineDialogWithoutAnalytics
                content = { <ReactionsMenu /> }
                isOpen = { isOpen }
                onClose = { onClose }
                placement = { _conferenceView === 'fixed' && getWindowWidth() >= 612 ? 'top' : 'left-start' }>
                {children}
            </InlineDialogWithoutAnalytics>
        </div>
    );
}

export default ReactionsMenuPopup;
